<template>
  <div class="mb-3">
    <span>
      <h5>
        <strong>{{ title }}</strong>
      </h5>
    </span>
    <div>
      <span>{{ subtitle }}</span>
      <textarea
        :placeholder="placeholder"
        class="form-control show-scrollbar"
        :class="[
          {
            'form-control-success': success && !error,
            'form-control-danger': !success && error,
          },
          computedClasses,
        ]"
        :required="required"
        :disabled="disabled"
        :maxlength="max"
        v-on:input="$emit('setter', $event.target.value)"
        @paste="$emit('setter', $event.target.value)"
        v-model="content"
        ref="textArea"
        @blur="$emit('at-blur')"
        :data-cy="`${dataCy}-input`"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextArea",
  emits:['mounted'],
  props: {
    title: String,
    subtitle: String,
    placeholder: String,
    success: Boolean,
    error: Boolean,
    required: Boolean,
    disabled: Boolean,
    input: String,
    dataCy: String,
    cssClass: Array,
    max: Number, default: null,
  },
  data() {
    return {
      content: this.input || null,
    };
  },
  model: {
    prop: "input",
    event: "setter",
  },
  computed: {
    computedClasses() {
      if (this.cssClass) return [...this.cssClass];
      return [];
    },
  },
  watch: {
    input: function (newValue) {
      if (newValue !== this.content) {
        this.content = newValue;
      }
    },
  },
  methods: {
    focus() {
      this.$nextTick(() => {
        this.$refs.textArea.focus();
      });
    },
  },
  mounted(){
    this.$emit("mounted");
    this.focus();

  }
};
</script>
<style lang="scss" scoped>
.show-scrollbar {
  overflow: visible;
}
</style>